export default "<p>add-tipo-contrato works!</p>\n"